import { FieldType } from '../../types/Field.type';
export const ProductChannelRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.product_channel.label',
    fallbackLabel: 'How do you plan to do your sales?',
    type: FieldType.Enum,
    options: [
        { key: 'IN_STORE', label: 'fields.enm.product_channel.options.IN_STORE', fallbackLabel: 'In-store and remote sales', description: 'fields.enm.product_channel.description.IN_STORE', fallbackDescription: 'Sales face-to-face with the added ability for remote sales. The customer gets the items right away.' },
        { key: 'TELESALES', label: 'fields.enm.product_channel.options.TELESALES', fallbackLabel: 'Remote sales only', description: 'fields.enm.product_channel.description.TELESALES', fallbackDescription: 'Sales are done over the phone. The customer doesn\'t get the items right away.' },
    ],
    trackFieldValueWithAnalytics: false,
};
